import { getSanitizedUserInfoObject } from "@features/mySph/utils/helpers";
import {
  FeedSSOUserDetailsResponse,
  SanitizedUserInfoObject,
} from "@features/mySph/utils/types";
import { tryCatch } from "@typings/TryCatch";
import axios from "axios";

/**
 * Fetch user info from BE using the access token.
 * @param accessToken - The access token to fetch user info from BE.
 * @returns The sanitized user info object.
 */
export const getUserInfoFromBE = async (
  accessToken: string
): Promise<SanitizedUserInfoObject | undefined> => {
  if (!accessToken) return;

  const request = axios.post<FeedSSOUserDetailsResponse>(
    `/_plat/api/v1/user/auth/validate`,
    {},
    {
      headers: {
        Authorization: accessToken,
      },
    }
  );

  const { data, error } = await tryCatch(request);
  if (error) return;

  const sanitizedUserInfo = getSanitizedUserInfoObject(data.data);

  return sanitizedUserInfo;
};
